import {forwardRef} from 'react'
import type {IconProps} from '../types'

export const ExclamationWarningAlertIcon = forwardRef<SVGSVGElement, IconProps>(
  ({size = 20, color = 'currentColor', className, ...props}, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path
        id="Icon"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.90835 3.71861C10.8259 2.08745 13.1744 2.08745 14.0919 3.71861L20.7883 15.6233C21.6882 17.2231 20.5321 19.1999 18.6965 19.1999H5.30376C3.46818 19.1999 2.31207 17.2231 3.21198 15.6233L9.90835 3.71861ZM13.2 15.6C13.2 16.2628 12.6628 16.8 12 16.8C11.3373 16.8 10.8 16.2628 10.8 15.6C10.8 14.9373 11.3373 14.4 12 14.4C12.6628 14.4 13.2 14.9373 13.2 15.6ZM12 6.00002C11.3373 6.00002 10.8 6.53728 10.8 7.20002V10.8C10.8 11.4628 11.3373 12 12 12C12.6628 12 13.2 11.4628 13.2 10.8V7.20002C13.2 6.53728 12.6628 6.00002 12 6.00002Z"
        fill={color}
      />
    </svg>
  ),
)

ExclamationWarningAlertIcon.displayName = 'ExclamationWarningAlertIcon'
